import { render, staticRenderFns } from "./CreateRole.vue?vue&type=template&id=1bcb547d"
import script from "./CreateRole.vue?vue&type=script&lang=js"
export * from "./CreateRole.vue?vue&type=script&lang=js"
import style0 from "./CreateRole.vue?vue&type=style&index=0&id=1bcb547d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports